function resizeParentAccordion(fromEl) {
	const panel = fromEl?.closest?.('.site-accordion__content, [class*="accordion"][class*="content"]');
	if (!panel) {
		return;
	}
	panel.style.maxHeight = panel.scrollHeight + 'px';
}

function attachInlineNewsletterHandlers() {
	if (window.__oltInlineNLAttached) {
		return;
	}
	window.__oltInlineNLAttached = true;

	document.addEventListener('submit', onSubmit, { capture: true });
	document.addEventListener('change', onChange, { capture: true });

	async function onSubmit(e) {
		const form = e.target;
		if (!(form instanceof HTMLFormElement) || !form.matches('form.newsletter-inline__form, form[data-newsletter-inline]')) {
			return;
		}

		e.preventDefault();

		const emailEl = form.querySelector('input[type="email"], input[name="email"]');
		const nameEl = form.querySelector('input[name="name"]');
		const optKey = form.getAttribute('data-optin-name') || 'opt_london_theatre_guide';
		// Look the consent box up by its opt-in name first, then fall back to
		// the checkbox within the consent wrapper. This keeps validation working
		// even if the markup name and data-optin-name ever drift apart.
		const consentEl = form.querySelector(`input[name="${ CSS.escape(optKey) }"]`)
			|| form.querySelector('.newsletter-inline__checkbox input[type="checkbox"]');
		const errorEl = form.querySelector('.newsletter-inline__msg--error');
		const okEl = form.querySelector('.newsletter-inline__msg--success');
		const btn = form.querySelector('button[type="submit"], [type="submit"]');

		// clear previous messages/validity
		if (errorEl) {
			errorEl.textContent = ''; errorEl.hidden = false; resizeParentAccordion(errorEl);
		}
		if (okEl) {
			okEl.textContent = ''; okEl.hidden = true;
		}
		consentEl?.setCustomValidity?.('');

		// ---- email required ----
		const email = (emailEl?.value || '').trim().toLowerCase();
		if (!email) {
			if (errorEl) {
				errorEl.innerHTML = '<p>Please enter your email address.</p>'; resizeParentAccordion(errorEl);
			}
			emailEl?.focus();
			return;
		}
		// ---- email valid ----
		const probe = document.createElement('input');
		probe.type = 'email'; probe.value = email;
		if (!probe.checkValidity()) {
			if (errorEl) {
				errorEl.innerHTML = '<p>Please enter a valid email address.</p>'; resizeParentAccordion(errorEl);
			}
			emailEl?.focus();
			return;
		}

		// ---- consent required (when checkbox is present) ----
		if (consentEl && consentEl.type === 'checkbox' && !consentEl.checked) {
			if (errorEl) {
				errorEl.innerHTML = '<p>Please tick the consent box.</p>'; resizeParentAccordion(errorEl);
			}
			consentEl.setCustomValidity?.('Please tick this box to receive our newsletter.');
			consentEl.reportValidity?.();
			return;
		}

		// ---- submit UX ----
		const prev = btn?.textContent;
		if (btn) {
			btn.disabled = true; btn.textContent = 'Submitting…';
			btn.style.maxWidth = '150px';
		}

		const payload = {
			email,
			newsletterType: 'static',
			first_name: (nameEl?.value || '').trim(),
			accept_terms: true,
			[ optKey ]: true
		};

		try {
			const res = await fetch('/wp-json/subscribers/all', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'same-origin',
				cache: 'no-store',
				body: JSON.stringify(payload)
			});

			if (res.ok) {
				if (okEl) {
					okEl.textContent = 'Thank you for signing up.'; okEl.hidden = false;
					if (errorEl) {
						errorEl.textContent = '';
					}
					form.reset();
					resizeParentAccordion(okEl);
				} else {
					form.innerHTML = "<h3 class='black'>Thank you for signing up.</h3>";
					resizeParentAccordion(form);
				}
			} else {
				const msg = (await res.json().catch(() => ({})))?.error || 'Something went wrong.';
				if (errorEl) {
					errorEl.innerHTML = `<p>Sorry, we couldn't subscribe you. ${ String(msg).replace(/</g, '&lt;') }</p>`;
					resizeParentAccordion(errorEl);
				}
				if (btn) {
					btn.disabled = false; btn.textContent = prev || 'Submit »';
				}
			}
		} catch {
			if (errorEl) {
				errorEl.innerHTML = '<p>Network error. Please try again.</p>';
				resizeParentAccordion(errorEl);
			}
			if (btn) {
				btn.disabled = false; btn.textContent = prev || 'Submit »';
			}
		}
	}

	function onChange(e) {
		const el = e.target;
		if (!(el instanceof HTMLInputElement)) {
			return;
		}

		// clear consent validity once user interacts
		const form = el.form;
		if (form && (el.type === 'checkbox' || el.type === 'radio')) {
			const optKey = form.getAttribute('data-optin-name') || 'opt_london_theatre_guide';
			if (el.name === optKey) {
				el.setCustomValidity('');
			}
		}
		// keep accordion sized to content changes
		resizeParentAccordion(el);
	}
}

export default function initInlineNewsletter() {
	attachInlineNewsletterHandlers();
}

if (typeof window !== 'undefined') {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', attachInlineNewsletterHandlers, { once: true });
	} else {
		attachInlineNewsletterHandlers();
	}
}
